import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { City } from 'src/app/_models/city.model';
import { PushNotification } from 'src/app/_models/push-notification.model';
import { MobileRoutes } from 'src/app/_models/routes.model';
import { AllSpecialitiesApi } from 'src/app/_services/allSpecialities.service';
import { CityService } from 'src/app/_services/city.service';
import { DoctorsService } from 'src/app/_services/doctors.service';
import { PushNotificationService } from 'src/app/_services/push-notification.service';
import { RoutesService } from 'src/app/_services/routes.service';
import { showNotification } from 'src/app/helpers/show-toast';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-push-notifications',
  templateUrl: './push-notifications.component.html',
  styleUrls: ['./push-notifications.component.scss'],
})
export class PushNotificationsComponent implements OnInit {
  pageTitle: string = 'Push Notifications';
  pushNotification: PushNotification = {
    notification: {
      title: '',
      body: '',
      sound: '',
      routeName: '',
      routeId: 0,
      appId: 0,
    },
    filteredModel: {
      appId: 0,
      gender: 0,
      CitiesList: [],
      specialitiesList: [],
      fromBirthdayDate: null,
      toBirthdayDate: null,
    },
  };

  specificRoute = false;
  selectedRoute: 1;
  sounds = [{ id: 'default', label: 'default' }];
  routes: MobileRoutes[];
  bsValue = new Date();
  bsRangeValue: Date[];
  maxDate = new Date();
  cities = [];
  dropdownSettings = {};
  selectedCities = [];
  selectedSpecialties = [];
  dropdownList = [];
  doctorTypes = [];
  isDoctorNotification = false;
  genderList = [
    { id: 0, label: 'All' },
    { id: 1, label: 'Male' },
    { id: 2, label: 'Female' },
  ];

  pushNotificationForm: FormGroup;
  isSubmited: boolean = false;

  constructor(
    private routesService: RoutesService,
    private spinner: NgxSpinnerService,
    private specialityService: AllSpecialitiesApi,
    private cityService: CityService,
    private _DoctorsService: DoctorsService,
    private pushNotificationService: PushNotificationService,
    private _formBuilder: FormBuilder,
    public toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.pushNotificationForm = this._formBuilder.group({
      isDoctorNotification: [false, [Validators.required]],
      notificationTitle: [null, [Validators.required]],
      notificationBody: [null, [Validators.required]],
      notificationSound: [null],
      notificationGender: [0],
      notificationRoute: [null],
      notificationSpecificRoute: [null],
      notificationSpecialties: [[]],
      notificationDoctorType: [null],
      notificationDateRange: [null],
      notificationCities: [[]],
    });

    this.routesService.getAllRoutes().subscribe((res) => {
      this.routes = res.data?.routes;
    });

    this.cityService.getAllCities().subscribe((res) => {
      this.cities = res.map((city) => {
        return {
          id: city.id,
          item_text: city.enName,
        };
      });
    });

    this.specialityService.getAllSpecialties().subscribe((res) => {
      this.dropdownList = res.data?.doctorSpecilaities.map((spec) => {
        return {
          id: spec.id,
          item_text: spec.name,
        };
      });
    });

    this._DoctorsService.getAllDoctorTypes().subscribe((res) => {
      this.doctorTypes = res.data;
    });

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'item_text',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      enableCheckAll: false,
    };
  }

  routeChanged(value): void {
    const route = this.routes.find((r) => r.id === +value);
    if (route) {
      this.pushNotification.notification.routeName = route.routeName;
      this.pushNotification.notification.routeId = route.routeId;
    } else {
      this.specificRoute = true;
    }
  }

  onPushNotificationSubmit() {
    this.isSubmited = true;

    this.pushNotification.notification.title =
      this.pushNotificationForm.value.notificationTitle;

    this.pushNotification.notification.body =
      this.pushNotificationForm.value.notificationBody;

    this.pushNotification.notification.sound =
      this.pushNotificationForm.value.notificationSound;

    if (this.pushNotificationForm.value.isDoctorNotification) {
      this.pushNotification.filteredModel.appId = 2;
    } else {
      this.pushNotification.filteredModel.appId = 1;
    }

    this.pushNotification.filteredModel.gender =
      this.pushNotificationForm.value.notificationGender;

    if (this.pushNotificationForm.value.notificationCities) {
      this.pushNotificationForm.value.notificationCities.map((city) =>
        this.pushNotification.filteredModel.CitiesList.push(city.id)
      );
    }

    if (this.pushNotificationForm.value.notificationSpecialties) {
      this.pushNotificationForm.value.notificationSpecialties.map((spec) =>
        this.pushNotification.filteredModel.specialitiesList.push(spec.id)
      );
    }

    if (this.pushNotificationForm.value.notificationDateRange) {
      this.pushNotification.filteredModel.fromBirthdayDate =
        this.pushNotificationForm.value.notificationDateRange[0];

      this.pushNotification.filteredModel.toBirthdayDate =
        this.pushNotificationForm.value.notificationDateRange[1];
    }

    if (this.pushNotificationForm.valid) {


      this.pushNotificationService
        .sendPushNotification(this.pushNotification)
        .subscribe((res) => {


          this.isSubmited = false;
          this.pushNotificationForm.reset();
          showNotification(
            'success',
            `Notification has been sent`,
            this.toastr
          );
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        });
    } else {
      showNotification(
        'danger',
        'You should fill the form fields with the correct data!',
        this.toastr
      );
    }
  }

  onAddPushNotification() {
    this.spinner.show();
    this.pushNotification.filteredModel.fromBirthdayDate = this.bsRangeValue[0];
    this.pushNotification.filteredModel.toBirthdayDate = this.bsRangeValue[1];
    this.selectedCities.map((city) =>
      this.pushNotification.filteredModel.CitiesList.push(city.id)
    );
    this.pushNotification.filteredModel.appId = this.isDoctorNotification
      ? 2
      : 1;
    this.isDoctorNotification &&
      this.selectedSpecialties.map((spec) =>
        this.pushNotification.filteredModel.specialitiesList.push(spec.id)
      );
    this.pushNotificationService
      .sendPushNotification(this.pushNotification)
      .subscribe((res) => {
        this.pushNotification = {
          notification: {
            title: '',
            body: '',
            sound: '',
            routeName: '',
            routeId: 0,
            appId: 0,
          },
          filteredModel: {
            appId: 0,
            gender: 0,
            CitiesList: [],
            specialitiesList: [],
            fromBirthdayDate: null,
            toBirthdayDate: null,
          },
        };
      });
  }
}
